/** @sfdc-extension-file SFDC_EXT_BRD_LOGIN_SIDEBAR */
import { useLocation } from 'react-router';
import { useConfig } from '@salesforce/storefront-next-runtime/config';
import { resolvePrefix, stripPathPrefix } from '@salesforce/storefront-next-runtime/site-context';
import { useCurrentSiteAndLocaleRef } from '@/hooks/use-current-site-and-locale-ref';
import type { AppConfig } from '@/types/config';

/**
 * Bare (unprefixed) path + search for the current location — suitable as a
 * `returnUrl` for `/login` and `/signup` (which re-apply the site/locale prefix).
 */
export function useBareReturnUrl(): string {
    const location = useLocation();
    const config = useConfig<AppConfig>();
    const { siteRef, localeRef } = useCurrentSiteAndLocaleRef();

    const currentPrefix = config.url?.prefix
        ? resolvePrefix({
              prefix: config.url.prefix,
              params: { siteId: siteRef, localeId: localeRef },
          })
        : '';
    const barePath = stripPathPrefix({ pathname: location.pathname, prefix: currentPrefix }) || '/';
    return `${barePath}${location.search}`;
}
